import { Link, usePage } from "@inertiajs/react";
import { dashboard_path, integrations_path } from "@/routes";
import { preference_path } from "@/routes";
import InertiaSharedProps from "@/types/inertia";
import { Box, Flex, Text, VStack } from "@chakra-ui/react";
import { usePostHog } from "posthog-js/react";
import { useAnalytics } from "@/hooks/useAnalytics";

interface NavItem {
  label: string;
  href: string;
}

const NAV_ITEMS: NavItem[] = [
  { label: "Home", href: dashboard_path() },
  { label: "Preferences", href: preference_path() },
  { label: "Integrations", href: integrations_path() },
];

const Sidebar = () => {
  const { url } = usePage();
  const { current_user } = usePage<InertiaSharedProps>().props;

  const posthog = usePostHog();
  const TRACK = useAnalytics();

  const isActive = (path: string) => (url || "").startsWith(path);

  const handleLogout = () => {
    TRACK.USER_SIGNED_OUT();
    posthog?.reset();
  };

  return (
    <Flex
      as="aside"
      w="240px"
      h="100vh"
      position="sticky"
      top={0}
      bg="primary-base"
      color="on-primary-base"
      p={6}
      flexDirection="column"
      overflowY="auto"
    >
      <Text fontSize="lg" fontWeight="semibold" mb={4}>
        Muro
      </Text>
      <VStack as="nav" gap={1} alignItems="stretch">
        {NAV_ITEMS.map((item) => (
          <Link key={item.label} href={item.href} style={{ textDecoration: "none" }}>
            <Box
              display="block"
              px={3}
              py={2}
              borderRadius="md"
              opacity={isActive(item.href) ? 1 : 0.8}
              color="on-primary-base"
              bg={isActive(item.href) ? "primary-bold" : "transparent"}
              _hover={{
                opacity: 1,
                bg: isActive(item.href) ? "primary-bold" : "primary-hover",
              }}
            >
              {item.label}
            </Box>
          </Link>
        ))}
      </VStack>
      {current_user && (
        <Box
          mt="auto"
          pt={4}
          fontSize="xs"
          color="on-primary-base"
          opacity={0.7}
          borderTopWidth="1px"
          borderColor="whiteAlpha.200"
        >
          <Flex alignItems="center" justifyContent="space-between">
            <Text>{current_user.first_name}</Text>
            <Link href="/session" method="delete" as="button" onClick={handleLogout} style={{ textDecoration: "none" }}>
              <Box
                cursor="pointer"
                px={2}
                py={1}
                borderRadius="md"
                color="on-primary-base"
                _hover={{
                  bg: "primary-hover",
                }}
              >
                Log out
              </Box>
            </Link>
          </Flex>
        </Box>
      )}
    </Flex>
  );
};

export default Sidebar;
